var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenantmanager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54 18h-8v-3.69a4 4 0 0 0 -2-3.47l-10-5.71a4 4 0 0 0 -4 0l-10 5.71a4 4 0 0 0 -2 3.47v5.69h-8a4 4 0 0 0 -4 4v32a4 4 0 0 0 4 4h32 12a4 4 0 0 0 4-4v-34a4 4 0 0 0 -4-4zm-44 38v-32h8v32zm32 0h-20v-32-9.69l10-5.71 10 5.71zm12 0h-8v-34h8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.07 40h-4a2 2 0 0 0 0 4h4a2 2 0 0 0 0-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30 19.09v2h-2a2 2 0 0 0 0 4h2v2a2 2 0 1 0 4 0v-2h2a2 2 0 0 0 0-4h-2v-2a2 2 0 0 0 -4 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantmanager);
export default __webpack_public_path__ + "static/media/tenantmanager.1aa8bddc.svg";
export { ForwardRef as ReactComponent };